module.exports = require("@material-ui/icons/Cancel");


//////////////////
// WEBPACK FOOTER
// external "@material-ui/icons/Cancel"
// module id = 559
// module chunks = 0